module.exports = __webpack_public_path__ + "static/media/shotGoal.4a01d7bf.jpg";